export default "__VITE_ASSET__E88omISd__"